import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { setActivePageTitle } from "../../actions/settings";

import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import CheckIcon from "@material-ui/icons/Check";
import BlockIcon from "@material-ui/icons/Block";

import LoadingOverlay from "../../components/LoadingOverlay";
import BonzaNotification from "../../components/BonzaNotification";
import FinancialAnalysisFilter from "../../components/reports/FinancialAnalysisFilter";

import config from "../../config";
import { updateChargesBulk } from "../../middleware/api/charges";
import { getProducts } from "../../middleware/api/products";
import { getBookingPartners } from "../../middleware/api/bookingPartners";
import {
  getFinanceToursReport,
  exportFinanceToursReport,
} from "../../middleware/api/reports";
import { green } from "@material-ui/core/colors";

class FinancialAnalysisToursPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      products: [],
      bookingPartners: [],
      data: false,
      filters: {},
      errors: [],
    };

    this.getData = this.getData.bind(this);
    props.dispatch(
      setActivePageTitle(`Financial analysis report for tour purchases`),
    );
  }

  componentWillMount() {
    getProducts({
      typeCodes: [`PACKAGES`, `TOURS`, `HIRES`],
    })
      .then((products) => {
        getBookingPartners({ limit: 1000 })
          .then((bookingPartners) => {
            this.setState(
              { products, bookingPartners: bookingPartners.data },
              this.getData,
            );
          })
          .catch(() => {
            this.setState({
              loading: false,
              errors: [`Unable to fetch booking partners`],
            });
          });
      })
      .catch(() => {
        this.setState({
          loading: false,
          errors: [`Unable to fetch products`],
        });
      });
  }

  getData() {
    this.setState({ loading: true });
    let filters = Object.assign({}, this.state.filters);
    filters.from = filters.fromDate
      ? moment(filters.fromDate).format(`YYYY-MM-DD`)
      : moment().format(`YYYY-MM-DD`);
    filters.to = filters.toDate
      ? moment(filters.toDate).format(`YYYY-MM-DD`)
      : moment().format(`YYYY-MM-DD`);
    getFinanceToursReport(filters)
      .then((data) => {
        this.setState({
          loading: false,
          data,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          errors: [`Unable to fetch the report data`],
        });
      });
  }

  markAll(purchaseId) {
    this.setState({ loading: true });
    updateChargesBulk(purchaseId, { addedToAccounting: true })
      .then(() => {
        this.getData();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  unmarkAll(purchaseId) {
    this.setState({ loading: true });
    updateChargesBulk(purchaseId, { addedToAccounting: false })
      .then(() => {
        this.getData();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  generateReport(data) {
    let dataRows = [];
    let itemcolor = 'red';
    let displayAddLink = "";
    let displayRemoveLink = "";

    let equipmentItemColor = 'red';
    let equipmentDisplayAddLink = "";
    let equipmentDisplayRemoveLink = "";

    data.map((item, itemIndex) => {
      if (item.chargesAdded === item.chargesTotal) {
        itemcolor = 'green';
        displayAddLink = "none";  // hide add link
        displayRemoveLink = "";   // show remove link
      }
      else {
        itemcolor = 'red';
        displayRemoveLink = "none"; // hide remove link
        displayAddLink = "";  // show add link
      }

      if (item.pe_chargesAdded === item.pe_chargesTotal) {
        equipmentItemColor = 'green';
        equipmentDisplayAddLink = "none";  // hide add link
        equipmentDisplayRemoveLink = "";   // show remove link
      }
      else {
        equipmentItemColor = 'red';
        equipmentDisplayRemoveLink = "none"; // hide remove link
        equipmentDisplayAddLink = "";  // show add link
      }

      let totalGrossSale = parseFloat(item.totalGross) + parseFloat(item.totalEquipmentCost);
      let discountRule = "";
      let partnerCommission = "";

      // Discount Rule
      if ( (item.discountType != null) || (item.discountType != undefined) ) {
        if (item.discountType == "ABSOLUTE") {
            discountRule = "$" + item.discountAmount + " off";
        } else {
            discountRule = item.discountAmount + "% off";
        }
      }

      if ( (item.partnercommission != null) || (item.partnercommission != undefined) ) {
        partnerCommission = parseFloat(item.partnercommission).toFixed(2);
      }

      dataRows.push(
        <TableRow key={`item_${itemIndex}`}>
            <TableCell>
            <Link
              to={`/purchases/edit-tour/${item.purchaseID}`}
              className="no-underline"
            >
              <Button variant="contained" size="small" color="primary">
                Edit
              </Button>
            </Link>
          </TableCell>
          <TableCell>
            <div>
              {item.chargesTotal ? (
                <div>
                  <div style={{ color: itemcolor }}>
                    {item.chargesAdded}/{item.chargesTotal} added
                  </div>
                  <div style={{display: displayAddLink}}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.markAll(item.purchaseID);
                      }}
                      title="Add all charges to accounting"
                    >
                      Add
                    </a>
                  </div>
                  <div style={{display: displayRemoveLink}}>
                    <a
                      href="javascript:void(0)"
                      onClick={() => {
                        this.unmarkAll(item.purchaseID);
                      }}
                      title="Remove all charges from the accounting"
                    >
                      Remove
                    </a>
                  </div>
                </div>
              ) : (
                <p>No payments created</p>
              )}
            </div>
          </TableCell>
          <TableCell>{moment(item.tourDate).format(config.momentDateFormat)}</TableCell>
          <TableCell>{item.productName}</TableCell>

          <TableCell>{item.purchaseID}</TableCell>
          <TableCell>{item.customerName}</TableCell>
          <TableCell>{item.status}</TableCell>
          <TableCell>${item.totalNet}</TableCell>

          <TableCell>{item.noOfAdult}</TableCell>
          <TableCell>${item.adultPrice}</TableCell>
          <TableCell>{item.noOfChildren}</TableCell>
          <TableCell>${item.childPrice}</TableCell>
          <TableCell>{item.noOfFamilyGroups}</TableCell>
          <TableCell>${item.familyRate}</TableCell>
          <TableCell>{item.noOfAddAdult}</TableCell>
          <TableCell>${item.additionalRate}</TableCell>
          <TableCell>{item.noOfAddChildren}</TableCell>
          <TableCell>${item.additionalRate}</TableCell>
          <TableCell>${item.totalGross}</TableCell>
          <TableCell>{item.noOfEBikes}</TableCell>
          <TableCell>{item.noOfBabySeats}</TableCell>
          <TableCell>{item.noOfTrailAlongs}</TableCell>
          <TableCell>{item.noOfKiddieCarriers}</TableCell>
          <TableCell>{item.noOfSmallKidsBikes}</TableCell>
          <TableCell>{item.noOfLargeKidsBikes}</TableCell>
          <TableCell>${item.totalEquipmentCost}</TableCell>
          {/* Total Gross Sale = TourSale + Equipment Cost */}
          <TableCell>${totalGrossSale}</TableCell>
          <TableCell>{item.voucherCode}</TableCell>
          <TableCell>{discountRule}</TableCell>
          <TableCell>${item.discountedAmount}</TableCell>
          <TableCell>{partnerCommission}</TableCell>
          <TableCell>${item.commission}</TableCell>
          <TableCell>{item.bookingSource}</TableCell>
          <TableCell>{item.travelAgency}</TableCell>
          <TableCell>{moment(item.purchaseDate).format(config.momentDateFormat)}</TableCell>
          <TableCell>{item.staffName}</TableCell>
          <TableCell>{item.bookingRefID}</TableCell>
          <TableCell>{item.purchaseID} - {item.bookingRefID}</TableCell>

          <TableCell>{item.travelerFirstname} {item.travelerLastname}</TableCell>
          <TableCell>{item.email}</TableCell>
          <TableCell>{item.originCountry}</TableCell>

          <TableCell>{item.famils === 1 ? <CheckIcon /> : <BlockIcon />}</TableCell>
        </TableRow>,
      );

      {if(item.pe_purchaseId != null)
          dataRows.push(
            <TableRow key={`item_${itemIndex}`}>
                <TableCell>
                <Link
                  to={`/purchases/edit-equipmpent/${item.tourPurchaseId}`}
                  className="no-underline"
                >
                  <Button variant="contained" size="small" color="primary">
                    Edit
                  </Button>
                </Link>
              </TableCell>
              <TableCell>
                <div>
                  {item.pe_chargesTotal ? (
                    <div>
                      <div style={{ color: equipmentItemColor }}>
                        {item.pe_chargesAdded}/{item.pe_chargesTotal} added
                      </div>
                      <div style={{display: equipmentDisplayAddLink}}>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.markAll(item.pe_purchaseId);
                          }}
                          title="Add all charges to accounting"
                        >
                          Add
                        </a>
                      </div>
                      <div style={{display: equipmentDisplayRemoveLink}}>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            this.unmarkAll(item.pe_purchaseId);
                          }}
                          title="Remove all charges from the accounting"
                        >
                          Remove
                        </a>
                      </div>
                    </div>
                  ) : (
                    <p>No payments created</p>
                  )}
                </div>
              </TableCell>
              <TableCell>
                {moment(item.tourDate).format(config.momentDateFormat)}
              </TableCell>
              {/*
                <TableCell>{item.productName}</TableCell>
              */}
              <TableCell>-</TableCell>
              {/* <TableCell>{item.purchaseID}</TableCell> */}

              <TableCell>{item.purchaseID}</TableCell>
              <TableCell>{item.customerName}</TableCell>
              {/* <TableCell>{item.status}</TableCell> */}
              <TableCell></TableCell>
              {/* <TableCell>${item.totalNet}</TableCell> */}
              <TableCell>${item.pe_totalGross}</TableCell>

              {/*
                <TableCell>{item.noOfAdult}</TableCell>
                <TableCell>${item.adultPrice}</TableCell>
                <TableCell>{item.noOfChildren}</TableCell>
                <TableCell>${item.childPrice}</TableCell>
                <TableCell>{item.noOfFamilyGroups}</TableCell>
                <TableCell>${item.familyRate}</TableCell>
                <TableCell>{item.noOfAddAdult}</TableCell>
                <TableCell>${item.additionalRate}</TableCell>
                <TableCell>{item.noOfAddChildren}</TableCell>
                <TableCell>${item.additionalRate}</TableCell>
              */}
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              {/* <TableCell>${item.pe_totalGross}</TableCell> */}
              <TableCell></TableCell>
              <TableCell>{item.pe_noOfEBikes}</TableCell>
              <TableCell>{item.pe_noOfBabySeats}</TableCell>
              <TableCell>{item.pe_noOfTrailAlongs}</TableCell>
              <TableCell>{item.pe_noOfKiddieCarriers}</TableCell>
              <TableCell>{item.pe_noOfSmallKidsBikes}</TableCell>
              <TableCell>{item.pe_noOfLargeKidsBikes}</TableCell>
              <TableCell>${item.pe_totalGross}</TableCell>

              {/* <TableCell>${totalGrossSale}</TableCell> */}
              <TableCell>${item.pe_totalGross}</TableCell>

              {/* <TableCell>{item.voucherCode}</TableCell>
              <TableCell>{discountRule}</TableCell>
              <TableCell>${item.discountedAmount}</TableCell>
              <TableCell>{partnerCommission}</TableCell>
              <TableCell>${item.commission}</TableCell>*/}
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>

              {/* <TableCell>{item.bookingSource}</TableCell>*/}
              <TableCell></TableCell>

              {/* <TableCell>{item.travelAgency}</TableCell> */}
              <TableCell></TableCell>

              {/* <TableCell>{moment(item.purchaseDate).format(config.momentDateFormat)}</TableCell> */}
              <TableCell>{moment(item.pe_purchaseDate).format(config.momentDateFormat)}</TableCell>


              {/* <TableCell>{item.staffName}</TableCell> */}
              <TableCell>{item.pe_staffName}</TableCell>

              {/* <TableCell>{item.bookingRefID}</TableCell>
              <TableCell>{item.purchaseID} - {item.bookingRefID}</TableCell> */}
              <TableCell></TableCell>
              <TableCell></TableCell>

              {/* <TableCell>{item.travelerFirstname} {item.travelerLastname}</TableCell>
              <TableCell>{item.email}</TableCell>
              <TableCell>{item.originCountry}</TableCell> */}
              <TableCell>{item.travelerFirstname} {item.travelerLastname}</TableCell>
              <TableCell>{item.email}</TableCell>
              <TableCell>{item.originCountry}</TableCell>
              
               {/* <TableCell>{item.famils === 1 ? <CheckIcon /> : <BlockIcon />}</TableCell> */}
              <TableCell></TableCell>
            </TableRow>,
          );
      }
    });

    return (
      <div>
        <Table padding="dense">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Accounting</TableCell>
              <TableCell>Tour Date</TableCell>
              <TableCell>Tour Type</TableCell>

              <TableCell>Bonza Booking ID</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Final Nett Sale</TableCell>

              <TableCell>Adults</TableCell>
              <TableCell>Adult Price</TableCell>
              <TableCell>Children</TableCell>
              <TableCell>Child Price</TableCell>
              <TableCell>Family</TableCell>
              <TableCell>Family Price</TableCell>
              <TableCell>Additional Adults</TableCell>
              <TableCell>Additional Adult price</TableCell>
              <TableCell>Additional Children</TableCell>
              <TableCell>Additional Child Price</TableCell>
              <TableCell>Total Tour/Hire Costs</TableCell>
              <TableCell>e-Bikes Required</TableCell>
              <TableCell>Baby Seats Required</TableCell>
              <TableCell>Trail Alongs Required</TableCell>
              <TableCell>Kiddie Carriers Required</TableCell>
              <TableCell>Small Kids Bikes Required</TableCell>
              <TableCell>Large Kids Bikes Required</TableCell>
              <TableCell>Total Equipment Cost</TableCell>
              <TableCell>Total Gross Sale</TableCell>

              <TableCell>Discount Code</TableCell>
              <TableCell>Discount Rule ($/%)</TableCell>
              <TableCell>Total Discount Applied</TableCell>
              <TableCell>Partner Commission Percentage</TableCell>
              <TableCell>Total Commission</TableCell>

              <TableCell>Booking Source</TableCell>
              <TableCell>Travel Agency</TableCell>
              <TableCell>Purchase Date</TableCell>
              <TableCell>Entered By</TableCell>
              <TableCell>Booking Reference ID</TableCell>
              <TableCell>Accounting Reference ID's</TableCell>

              <TableCell>Traveller Name</TableCell>
              <TableCell>Traveller Email</TableCell>
              <TableCell>Country</TableCell>

              <TableCell>Famils</TableCell>              
            </TableRow>
          </TableHead>
          <TableBody>{dataRows}</TableBody>
        </Table>
      </div>
    );
  }

  onSearch(filters) {
    this.setState({ filters }, this.getData);
  }

  onExport(filters) {
    filters.from = filters.fromDate
      ? moment(filters.fromDate).format(`YYYY-MM-DD`)
      : moment().subtract(1, `month`).format(`YYYY-MM-DD`);
    filters.to = filters.toDate
      ? moment(filters.toDate).format(`YYYY-MM-DD`)
      : moment().format(`YYYY-MM-DD`);
    this.setState({ filters }, () => {
      exportFinanceToursReport(this.state.filters);
    });
  }

  render() {
    let loadingOverlay = false;
    if (this.state.loading) {
      loadingOverlay = <LoadingOverlay />;
    }

    let report = false;
    if (Array.isArray(this.state.data) && this.state.data.length > 0) {
      report = this.generateReport(this.state.data);
    } else {
      report = <p>No data to display</p>;
    }

    return (
      <div style={{ position: `relative` }}>
        {loadingOverlay}
        <FinancialAnalysisFilter
          products={this.state.products}
          bookingPartners={this.state.bookingPartners}
          searchHandler={this.onSearch.bind(this)}
          exportHanlder={this.onExport.bind(this)}
        />
        <Divider />
        <div>{report}</div>
        <BonzaNotification
          errors={this.state.errors}
          onClose={() => {
            this.setState({ errors: [] });
          }}
        />
      </div>
    );
  }
}

export default FinancialAnalysisToursPage;



/** WEBPACK FOOTER **
 ** ./src/containers/reports/FinancialAnalysisToursPage.js
 **/